<template>
  <div class="connector">
    <div class="header">
      <div class="text">
        <h1>我的连接器</h1>
        <span>零代码方式实现钉钉和企业的各类系统之间的集成</span>
      </div>
      <div class="btns">
        <el-input
          prefix-icon="el-icon-search"
          style="width: 200px; margin-right: 15px"
          placeholder="查找"
          v-model="connectorName"
          clearable
          @change="onChange"
        ></el-input>
        <el-button type="primary" class="el-icon-plus" @click="onAddClick">
          创建连接器</el-button
        >
      </div>
    </div>
    <div class="tabs">
      <el-tabs v-model="activeName" class="md-tabs" @tab-click="handleClick">
        <el-tab-pane  label="自建连接器"  name="connector">
          <new-table ref="table" :data="tableData" :columns="columns" :pages="pages" />
        </el-tab-pane>
        <el-tab-pane  label="已订阅连接器" name="Ordered-connector">
          <new-table
            ref="table"
            :data="Data"
            :columns="mcolumns"
            :pages="pages"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <add-connector
      ref="addConnector"
      :data="tableData"
      @success="getConnectorListData"
    ></add-connector>
  </div>
</template>
<script>
import newTable from "@/components/new-table";
import connector from "@/apis/connector";
import addConnector from "./components/add-connector";
import { Clipboard } from "@/utils/util";
export default {
  name: "connector",
  props: {},
  components: { newTable, addConnector },
  data() {
    return {
      activeName: "connector",
      layout: "prev, pager, next, total",
      tableData: [],
      Data: [],
      dataCount: "",
      connectorName: "",
      columns: [
        {
          label: "名称",
          prop: "connectorName",
          render: (h, { row }) => {
            return (
              <div
                class="connectorName "
                onClick={() =>
                  this.$router.push(`/connector-detail?id=${row.id}`)
                }
              >
                {row.connectorName}
              </div>
            );
          },
        },
        {
          label: "上架状态",
          width: "200",
          render: (h, { row }) => {
            switch (row.listingStatus) {
              case 0:
                return <div>未上架</div>;
              case 1:
                return <div>审核中</div>;
              case 2:
                return <div>已上架</div>;
              default:
                return row.listingStatus;
            }
          },
        },
        {
          label: "操作",
          width: "180",
          render: (h, { row }) => {
            return (
              <div>
                <el-button
                  type="text"
                  onClick={() =>
                    this.$router.push(`/connector-detail?id=${row.id}`)
                  }
                >
                  查看详情
                </el-button>
                <el-button type="text" onClick={() => Clipboard(`${row.id}`)}>
                  复制ID
                </el-button>
                <el-button
                  type="text"
                  onClick={() => {
                    this.deleteBtn(row.id);
                  }}
                >
                  删除
                </el-button>
              </div>
            );
          },
        },
      ],
      mcolumns: [
        {
          label: "名称",
          prop: "connectorName",
          render: (h, { row }) => {
            return (
              <div
                style="color: #3d9cfc;cursor: pointer"
                onClick={() =>
                  this.$router.push(`/connector-detail?id=${row.id}`)
                }
              >
                {row.connectorName}
              </div>
            );
          },
        },
      ],
      pages: {
        props: {
          "page-size": 10,
          "current-page": 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.pageChange(p);
          },
        },
      },
    };
  },
  created() {
    this.getConnectorListData();
  },
  methods: {
    async getConnectorListData() {
      let res = await connector.getConnectorList({
        pageIndex: this.pages.props["current - page"],
        pageSize: this.pages.props["current-change"],
        connectorName: this.connectorName,
      });
      this.tableData = res.data;
      this.pages.props.total = res.dataCount;
    },
    handleClick() {},
    onChange() {
      this.getConnectorListData();
    },
    onAddClick() {
      this.$refs.addConnector.open();
    },
    async deleteBtn(id) {
      await this.$confirm("确定要删除这个连接器？", {
        type: "warning",
      });
      await connector.deleteConnector(id);
      this.$message.success(`删除成功！`);
      this.getConnectorListData();
    },
  },
};
</script>
<style scoped lang="scss">
.connector {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  height: 50px;
  display: flex;
  justify-content: space-between;
}

.header h1 {
  display: inline-block;
  color: #262626;
}
.header span {
  font-size: 14px;
  color: #919191;
  margin-left: 10px;
}
.tabs{
  display: flex;
  flex: 1;
}

::v-deep {
  .connectorName:hover {
    cursor: pointer;
    color: #3d9cfc;
    text-decoration: underline;
  }
  .connectorName:hover .small-icon {
    display: inline-block;
    font-size: 16px;
    color: #000;
  }

  .small-icon {
    float: right;
    display: none;
  }
  .el-table__body-wrapper {
    height: 100% !important ;
  }
}
</style>
